import { render } from "./KoruTabbedViewer.vue?vue&type=template&id=12024211&ts=true"
import script from "./KoruTabbedViewer.vue?vue&type=script&lang=ts"
export * from "./KoruTabbedViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__